import React from "react";
import PropTypes from "prop-types";
import AppConfig from "../../../../config/AppConfig";
import IframeModal from "../../../../components/Modals/IframeModal";
import Page from "../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";

export class UserEventGuestPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requiredDataTimedOut: false
        }
        this.errorBoxStyle = {
            minHeight: "220px"
        }
        this.waitingDataTimeout = null;
    }

    componentDidMount() {
        if (!this.hasRequiredData()) {
            this.waitingDataTimeout = setTimeout(this.handleRequiredDataTimeout, 2000);
        }
    }

    componentWillUnmount() {
        this.clearWaitingDataTimeout();
    }

    hasRequiredData = _ => !!this.props.eventLink

    clearWaitingDataTimeout = _ => {
        if (this.waitingDataTimeout) {
            clearTimeout(this.waitingDataTimeout);
            this.waitingDataTimeout = null;
        }
    }

    handleRequiredDataTimeout = _ => {
        this.setState({requiredDataTimedOut: !this.hasRequiredData()});
    }


    render() {
        //Se dovesse esserci qualche problema spiego all'utente come risolvere
        if (!this.props.eventLink) {
            return <Page
                title={"Riserva il tuo posto"}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                onLeftIconClick={this.props.onDismiss}
                active={true}
                noPadding={true}
                content={
                    <div
                        className={"d-flex align-items-center justify-content-center text-center text-muted p-3"}
                        style={this.errorBoxStyle}>
                        { this.state.requiredDataTimedOut ?
                            "Impossibile caricare la pagina. Prova ad incollare il link sul tuo browser preferito." :
                            "Caricamento delle informazioni in corso..."}
                    </div>
                }
            />
        }

        const iframeParams = new URLSearchParams();
        iframeParams.append("event_code", this.props.eventLink);

        return (
            <IframeModal
                onDismiss={this.props.onDismiss}
                title={"Riserva il tuo posto"}
                src={`${AppConfig.webServerUrl}/api/user/module-events/guest-view/app?${iframeParams.toString()}`}
            />
        );
    }
}

UserEventGuestPage.propTypes = {
    onDismiss: PropTypes.func,
    eventLink: PropTypes.string
}
